import axios from './axios';
import SETTINGS from '../settings'
export default {
    getSettingCompany(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/settingcompany`, {params: params}).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    }
}